const ossUrl = import.meta.env.VITE_GLOB_OSS_BASE_URL || 'https://electronic-color-card-test-dev.oss-cn-shenzhen.aliyuncs.com';

export const OSSImgUrl = (url) => {
  if (url) {
    if (url.startsWith('https://') || url.startsWith('http://')) {
      return url;
    }
    return `${ossUrl}/${url}`;
  }
};

export const aboutOssUmgUrl = (url) => {
  const ossUrl = 'https://oss.waperidea.cn'
  if (url) {
    if (url.startsWith('https://') || url.startsWith('http://')) {
      return url;
    }
    return `${ossUrl}/${url}`;
  }
}

export const isMobile = () => {
  if (typeof window === 'undefined') return false;
  const flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag || window.innerWidth <= 960;
};

export const isPC = () => {
  return !isMobile();
};

/** 图片预加载 */
export const preloadImages = (urls) => {
  const promises = [];
  urls.forEach((url) => {
    const img = new Image();
    promises.push(
      new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = reject;
      })
    );
    img.src = url;
  });
  return Promise.all(promises);
};

/** 设备是否允许自动播放视频 */
export const isMobileCanPlay = () => {
  if (isMobile()) {
    return overIOS13();
  } else {
    return true;
  }
};

/** 系统版本号大于13 */
export const overIOS13 = () => {
  var ua = navigator.userAgent.toLowerCase();
  if (
    ua.indexOf("Android") > -1 ||
    ua.indexOf("Adr") > -1 ||
    ua.indexOf("android") != -1
  ) {
    return true;
  }
  if (ua.indexOf("like mac os x") > 0) {
    var reg = /os [\d._]*/gi;
    var verinfo = ua.match(reg);
    var version = (verinfo + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, ".");
    var arr = version.split(".");
    if (arr[0] >= 12 && window.DeviceMotionEvent) {
      return false;
    } else {
      return true;
    }
  }
  return true;
};

/** 播放视频 */
export const playVideo = (el, autoPause = false) => {
  if (!el) return;
  try {
    if (el?.readyState >= 2) {
      el?.play();
      if (autoPause) {
        setTimeout(() => {
          el?.pause();
        }, 500);
      }
    } else {
      el?.addEventListener("loadedmetadata", () => {
        el?.play();
        if (autoPause) {
          setTimeout(() => {
            el?.pause();
          }, 500);
        }
      });
      el?.load();
    }
  } catch (error) {
    console.log("播放视频失败:", error);
  }
};

/** 播放视频（不判断） */
export const justPlayVideo = (el) => {
  if (!el) return;
  try {
    if (el?.readyState >= 2) {
      el?.play();
    } else {
      el?.addEventListener("loadedmetadata", () => {
        el?.play();
      });
      el?.load();
    }
  } catch (error) {
    console.log("播放视频失败:", error);
  }
};

/** 暂停视频 */
export const pauseVideo = (el) => {
  if (!el || typeof el?.pause != "function") return;
  el?.pause();
};

/** 释放视频资源 */
export const releaseVideo = (el) => {
  el?.pause();
  el.src = "";
  el = null;
};

/** 监听视频可见性 */
export const observeVideo = (el, autoPause = false) => {
  if (!el) return;

  const options = {
    rootMargin: "0px",
    threshold: 0.5,
  };

  if (window.IntersectionObserver) {
    const observer = new window.IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          playVideo(el, autoPause);
        } else {
          pauseVideo(el);
        }
      });
    }, options);
    observer.observe(el);
  } else {
    playVideo(el, autoPause);
  }
};

/** 获取 Vite 的本地图片路径 */
export const getLocalImageUrl = (path) => {
  return new URL(path, import.meta.url).href;
};
